import React, { useEffect, useState } from 'react';
import {
  Modal, Box, Typography, IconButton, TextField, Button, Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CommentBox from '../Shared/CommentBox/index.tsx';
import { CampaignListActions } from '../../Services/_actions';
import { useSnackBar } from '../FlowBuilder/Common/SnackBar/index.tsx';

export interface Comment {
  user_name: string;
  timestamp: string; // ISO string
  comment: string;
}

interface ViewCommentModalProps {
  open: boolean;
  onClose: () => void;
  campaign: any;
}

const ViewCommentModal: React.FC<ViewCommentModalProps> = ({
  open,
  onClose,
  campaign
}) => {
  const actions = CampaignListActions();
  const [commentList, setCommentList] = useState<any>([]);
  const { showSnackBar } = useSnackBar();

  const getComments = async () => {
    try {
      const proposalId = campaign?.proposal?.proposal_id||campaign.proposal_id;
      if (campaign && proposalId) {
        console.log("Fetching comments for campaign:", campaign?.proposal_id);

        const response = await actions.getCampaignComments(proposalId, 'CAMPAIGN');
      console.log("getCampaignComments response:", response);

        if (response && response.status === 200) {
          console.log("Comments fetched successfully:", response.data);
          const generalComments = response?.data?.null?.general ||response?.data?.general|| [];
          setCommentList([...generalComments]);
        } else {
          showSnackBar("Error occurred while fetching comments", "error");
        }
      }
    } catch (error) {
      console.error("Error fetching comments:", error);
      // showSnackBar(error?.toString() || "Error", "error");
    }
  };

  const addComment = async (commentText: string) => {
    const proposalId = campaign?.proposal?.proposal_id||campaign.proposal_id;

    try {
      if (campaign && proposalId && commentText) {
        const response = await actions.addCampaignComment(proposalId, commentText);
        if (response && response.status === 200) {
          showSnackBar("Comment added successfully", "success");
          getComments();
        } else {
          showSnackBar("Failed to add comment", "error");
        }
      }
    } catch (error) {
      showSnackBar(error?.toString() || "Error", "error");
    }
  };
  useEffect(() => {
    getComments()
  }, [campaign])

  const campaignName = campaign?.proposal?.name || campaign?.name || 'Unnamed Campaign';

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: 2,
        p: 4,
        width: 600,
        maxHeight: '90vh',
        overflowY: 'auto',
      }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6" fontWeight="bold">
            View Comments For {campaignName}
          </Typography>
          <IconButton onClick={onClose}><CloseIcon /></IconButton>
        </Box>
        <CommentBox commentList={commentList || []} onSubmitComment={(commentText) => addComment(commentText)} />
      </Box>
    </Modal>
  );
};

export default ViewCommentModal;
